<template>
  <!-- WMS-Bestandsauswahl (Umlagerung/Anpassung mobil): SKU suchen, konkreten Eintrag waehlen.
       Scan fuellt die SKU vor, sodass man alle Eintraege dieser SKU sieht (Trello 21.08.). -->
  <div>
    <div class="m-wms-form__row">
      <div class="m-wms-form__field">
        <label>{{ $t("mobile.wms.stockEntry") }} *</label>
        <input v-model="query" :placeholder="$t('mobile.wms.stockPlaceholder')" @input="debouncedSearch" @focus="debouncedSearch" />
      </div>
      <m-wms-photo-button kind="ean" @extracted="onPhotoResult" @extract-error="photoError = $t('mobile.wms.photoReadError')" />
      <button type="button" class="m-wms-form__iconbtn" @click="scannerOpen = true"><i class="material-icons">qr_code_scanner</i></button>
    </div>
    <p v-if="photoError" class="m-wms-form__error">{{ photoError }}</p>
    <ul v-if="entries.length && !value" class="m-wms-suggest">
      <li v-for="e in entries" :key="e.id" @click="choose(e)">
        <strong>{{ e.sku }}</strong> · {{ e.warehouseCode }}-{{ e.storageLocation }} · {{ $t("mobile.wms.free") }}: {{ e.inventory - e.reserved }} ({{ e.inventory }}/{{ e.reserved }})
      </li>
    </ul>
    <p v-if="searching" class="m-wms-form__error" style="color: #78909c">{{ $t("mobile.loading") }}</p>
    <div v-if="value" class="m-wms-form__field m-wms-picked" @click="reset">
      <label>{{ $t("mobile.wms.selectedEntry") }}</label>
      <div>
        <strong>{{ value.sku }}</strong> · {{ value.warehouseCode }}-{{ value.storageLocation }} · {{ $t("mobile.wms.inventory") }} {{ value.inventory }} / {{ $t("mobile.wms.reservedShort") }}
        {{ value.reserved }}
        <i class="material-icons" style="font-size: 16px; vertical-align: middle">close</i>
      </div>
    </div>

    <m-barcode-scanner v-if="scannerOpen" @scanned="onScanned" @close="scannerOpen = false" />
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import WarehouseService from "@/services/warehouse.service";
import MBarcodeScanner from "../components/MBarcodeScanner.vue";
import MWmsPhotoButton from "./MWmsPhotoButton.vue";

export default {
  name: "MWmsInventoryPicker",
  components: { MBarcodeScanner, MWmsPhotoButton },
  props: {
    value: { type: Object, default: null }, // VWWarehouseInventory-Zeile
  },
  data() {
    return { query: "", entries: [], scannerOpen: false, searching: false, photoError: null };
  },
  created() {
    this.debouncedSearch = debounce(this.search, 350);
  },
  methods: {
    async search() {
      const q = this.query.trim();
      if (q.length < 2) {
        this.entries = [];
        return;
      }
      this.searching = true;
      try {
        const res = await WarehouseService.getWarehouseInventories({ sku: q, pageIndex: 0, pageSize: 200 });
        this.entries = res.data || [];
      } finally {
        this.searching = false;
      }
    },
    choose(entry) {
      this.entries = [];
      this.query = entry.sku;
      this.$emit("input", entry);
    },
    reset() {
      this.$emit("input", null);
      this.debouncedSearch();
    },
    onScanned({ value }) {
      // GTIN vom Scanner darf stehen bleiben: die Bestandssuche loest sie serverseitig zur SKU auf
      this.scannerOpen = false;
      this.photoError = null;
      this.query = String(value || "")
        .trim()
        .toUpperCase();
      this.$emit("input", null);
      this.search();
    },
    onPhotoResult(r) {
      // Gelesene SKU als Suchbegriff uebernehmen - der Nutzer waehlt dann den konkreten Eintrag
      this.photoError = null;
      if (r && r.sku) {
        this.query = r.sku;
        this.$emit("input", null);
        this.search();
      } else {
        this.photoError = this.$t("mobile.wms.photoReadFailed");
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./m-wms.scss"></style>

<style lang="scss" scoped>
.m-wms-picked {
  border: 1px solid #c6d6a5;
  background: #f2f6eb !important;
  cursor: pointer;
}
</style>
